export type DataKeys =
  | 'test'
  | 'track'
  | 'track-section'
  | 'track-text'
  | 'track-url'
  | 'track-value';

export type ExtendDataKeys<T extends string> = DataKeys | T;

export type DataAttributeMap<T extends string = DataKeys> = Partial<
  Record<T, string | number | boolean | null | undefined>
>;

export const createDataAttributes = <T extends string>(
  data: DataAttributeMap<ExtendDataKeys<T>> = {}
): Record<string, string> => {
  if (!data || typeof data !== 'object') return {};

  return Object.entries(data).reduce(
    (acc, [key, value]) => {
      if (value !== undefined && value !== null) {
        acc[`data-${key}`] = String(value);
      }
      return acc;
    },
    {} satisfies Record<string, string>
  );
};
